import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getContactDataByNameShorthand } from '../../../state/customer/customer.actions';
import { selectSelectedContact } from '../../../state/customer/customer.selector';
import { GatewayContact } from '../../../models/GatewayContact';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GatewayOrder } from '../../../models/GatewayOrder';
import { CustomerState } from '../../../state/customer/customer.reducer';

@Component({
  selector: 'app-contact-widget',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatTooltipModule],
  templateUrl: './contact-widget.component.html',
  styleUrl: './contact-widget.component.css'
})
export class ContactWidgetComponent implements OnChanges {
  @Input() gatewayOrder: GatewayOrder | null = null;
  contact$: Observable<GatewayContact | null>;

  constructor(private store: Store<{customer: CustomerState}>) {
    this.contact$ = this.store.select(selectSelectedContact);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['gatewayOrder'] && this.gatewayOrder?.contact) {
      this.store.dispatch(getContactDataByNameShorthand({ shorthand: this.gatewayOrder.contact }));
    }
  }
}